$(document).ready(() => {
  // $('.newsletter-form-group__submit').click(function(e) {
  //   e.preventDefault();
  //   email = $(this).parent().find('.newsletter-form-group__input').val();
  //   if (!email) return;
  //   console.log(email);

  //   // $.post('/contact', {
  //   //   form_type: 'customer',
  //   //   utf8: '✓',
  //   //   contact: {
  //   //     tags: 'prospect,newsletter',
  //   //     context: 'popup',
  //   //     email,
  //   //   },
  //   // })
  //   //   .then((res) => {
  //   //     console.log(res);
  //   //   });

  //   // const data = {
  //   //   form_type: 'customer',
  //   //   utf8: '✓',
  //   //   contact: {
  //   //     tags: 'prospect,newsletter',
  //   //     context: 'password',
  //   //     email,
  //   //   },
  //   //   commit: '',
  //   // }
  //   // const headers = {
  //   //   'Content-Type': 'application/x-www-form-urlencoded',
  //   // }
  //   // $.ajax({
  //   //   url: '/contact#newsletter-`',
  //   //   type: 'POST',
  //   //   async: true,
  //   //   headers,
  //   //   data,
  //   //   success: (data) => {
  //   //     console.log('success');
  //   //     console.log(data);
  //   //   },
  //   //   error: (err) => {
  //   //     console.log('error');
  //   //     console.log(err);
  //   //   },
  //   // });
  // });
});
